import bidEditComponent from './bid-edit.component';

const bidEditModule = angular.module('bidEdit', [
])
  .component('bidEdit', bidEditComponent)
  .name;

export default bidEditModule;
